const SITE_URL = "https://relocationclarity.com";

export default function SeoArticleSchema({
  headline,
  description,
  pathname,
  keywords = [],
}) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline,
    description,
    inLanguage: "en-US",
    isAccessibleForFree: true,
    mainEntityOfPage: `${SITE_URL}${pathname}`,
    url: `${SITE_URL}${pathname}`,
    publisher: {
      "@type": "Organization",
      name: "Relocation Clarity",
      url: SITE_URL,
    },
    author: {
      "@type": "Organization",
      name: "Relocation Clarity",
    },
  };

  if (keywords.length) {
    schema.keywords = keywords.join(", ");
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}